import React, { ReactNode, useContext } from "react";
import { useSelector } from "react-redux";

import { FormEngineSelectors } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { DefaultWidgetMap } from "@com.mgmtp.a12.formengine/formengine-core/lib/view";
import { AutocompleteProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/input/autocomplete";

import { ActivityIdContext } from "../../../component/ActivityContext";
import { assertNonNullable } from "../../../utilities/assert";
import { getValueFromEntityInstancePath } from "../../../utilities/pathHelpers";
import { isDocument, isString } from "../../../utilities/typeGuardUtils";

import { ModulFDataContext } from "./contexts";

export function CustomAutocomplete(props: AutocompleteProps): ReactNode {
	const activityId = useContext(ActivityIdContext);
	assertNonNullable(activityId);

	const document = useSelector(FormEngineSelectors.dataState(activityId)).document;
	const dataContext = React.useContext(ModulFDataContext);

	if (props.value !== "" || !props.id || !isDocument(document) || !dataContext) {
		return <DefaultWidgetMap.Autocomplete {...props} />;
	}

	const fieldValue = getValueFromEntityInstancePath(dataContext, document);

	if (fieldValue && isString(fieldValue) && !fieldValue.startsWith("/root")) {
		return <DefaultWidgetMap.Autocomplete {...props} value={fieldValue} />;
	}

	return <DefaultWidgetMap.Autocomplete {...props} />;
}
